import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {IFiles} from '../../ViewItems/viewfiles/viewfiles.component';
import {CalendarEvent} from 'angular-calendar';

import {GlobalObjectService} from '../../../../class/global-obj';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {HttpFormDataService} from '../../../../services/services';

import * as moment_ from 'moment';
import {Router} from '@angular/router';

const moment = moment_;

@Component({
    selector: 'noos-calendar-view',
    templateUrl: './calendar-view.component.html',
    styleUrls: ['./calendar-view.component.scss']
})

@NoosFormTypeService.register('calendarview')
export class CalendarViewComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId: 0;

    fileList: IFiles[] = [];


    settings =
        {
            textColor: '',
            bandColor: '',
            headerColor: '',
            view: [300, 300],
            fitInContainer: false,
        };

    view = [300, 300];

    uid = '';
    count = 0;

    viewDate: Date = new Date();
    showDate = 'TAKVİM';
    setting: IHttpSetting;
    locale = 'tr';
    footerInfo = '...';
    lastDayFactor = 0;


    calendarData: any = [];

    constructor(private httpService: HttpFormDataService, public router: Router) {
        this.setting = GlobalObjectService.getVar('setting');
        this.locale = this.setting.env[0].locale;
    }


    loadEvent(dayFactor, noCache = false) {
        this.lastDayFactor = dayFactor;
        moment.locale(this.locale);
        const date = dayFactor ? moment(new Date()).add(dayFactor, 'days') : moment(new Date());
        this.viewDate = new Date(date.format('YYYY-MM-DD'));
        this.showDate = date.format('D.M.YYYY dddd');

        const _day = date.date();
        const _month = date.month() + 1;
        const _year = date.year();
        this.calendarData = [];
        this.count = 0;
        this.httpService.dashboard_calendar(this.setting, this.uid, _year, _month, _day, noCache).subscribe(ret => {
            if (ret.complete && ret.data) {
                this.calendarData = ret.data.map((ret2: any) => {
                    const owner = ret2.owner;
                    return {
                        title: ret2.title,
                        start: new Date(
                            ret2.event_date
                        ),
                        color: {
                            primary: '#9B5DE5',
                            secondary: '#9B5DE5',
                        },
                        allDay: ret2.allday,
                        meta: {
                            name: owner
                        },
                    };
                });
                console.log('this.calendarData:', this.calendarData);
                this.count = this.calendarData.length;
                this.footerInfo = moment(new Date()).add(-1 * ret.diff, 'minutes').startOf('minute').fromNow();
            }
        });
    }

    ngOnInit() {
        Object.assign(this, this.prop.options);

        if (this.settings && this.settings.view && this.settings.view.length > 0) {
            this.view = this.settings.view;
        }


    }

    ngAfterViewInit(): void {

        this.loadEvent(0);

    }

    showInDate(dayFactor) {
        this.loadEvent(dayFactor, true);
    }

    refresh() {
        this.loadEvent(0, true);
    }

    eventClicked({event}: { event: CalendarEvent }): void {
        const date = moment(event.start);
        this.router.navigate(['calendar']);
    }
}
